import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedLayoutModule } from "./layouts/shared-layout.module";
import { CommonActionColumnModule } from "./modules/common-action-column/common-action-columns.module";
import { PhotoCardComponent } from "./components/photo-card/photo-card.component";
import { RouterModule } from "@angular/router";
import { SuccessPageComponent } from "./components/success-page/success-page.component";
import { TagInputModule } from "ngx-chips";
import { FormsModule } from "@angular/forms";
import { IgxInputGroupModule, IgxSliderModule } from "igniteui-angular";
import { MySlidePanelComponent } from "./components/my-slide-panel/my-slide-panel.component";
import { InputTextClearDirective } from "./directives/input-text-clear/input-text-clear.directive";
import { LazyLoadDirective } from "./directives/lazy-load/lazy-load.directive";
import { ClearButtonComponent } from "./directives/input-text-clear/components/clear-button/clear-button.component";
import { NgxCroppieModule } from "./modified_modules/ngx-croppie/ngx-croppie.module";
import { PhotoTooltipsComponent } from "./components/photo-tooltips/photo-tooltips.component";
import { NgbModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { LogoutAllComponent } from "./utils/logout-all.component";
import { ReviewPopupComponent } from "../modules/photo/photo-review/review-popup/review-popup.component";
import { RatingStarComponent } from "./components/rating-star/rating-star.component";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { Angular2PromiseButtonModule } from "angular2-promise-buttons";
import { SharedPipeModule } from "./pipes/shared.pipe.module";
import { CarouselPhotoComponent } from "./components/carousel-photo/carousel-photo.component";
import { RestartingPopupComponent } from "./components/restarting-popup/restarting-popup.component";
import { PopupMarkerComponent } from "./components/popup-marker/popup-marker.component";
import { VideoCardComponent } from "./components/video-card/video-card.component";
import { CPipeModule } from "../core/pipes/c-pipe.module";
import { UserPagePublicComponent } from "./components/user-page-public/user-page-public.component";
import { NgxMasonryModule } from "ngx-masonry";
import { ContactPopupComponent } from "./components/user-page-public/contact-popup/contact-popup..component";
import { RegisterPageComponent } from "./components/register-page/register-page.component";
import { PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { TravelKitTabComponent } from "./components/travel-kit-tab/travel-kit-tab.component";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { IconModule } from "src/assets/icons/icons.module";

@NgModule({
  declarations: [
    PhotoTooltipsComponent,
    ClearButtonComponent,
    PhotoCardComponent,
    VideoCardComponent,
    SuccessPageComponent,
    MySlidePanelComponent,
    InputTextClearDirective,
    LazyLoadDirective,
    ClearButtonComponent,
    LogoutAllComponent,
    ReviewPopupComponent,
    RatingStarComponent,
    CarouselPhotoComponent,
    RestartingPopupComponent,
    PopupMarkerComponent,
    UserPagePublicComponent,
    ContactPopupComponent,
    RegisterPageComponent,
    TravelKitTabComponent,
  ],
  imports: [
    SharedPipeModule,
    RouterModule,
    TagInputModule,
    CommonModule,
    SharedLayoutModule,
    CommonActionColumnModule,
    FormsModule,
    NgxCroppieModule,
    NgbTooltipModule,
    NgbModule.forRoot(),
    IgxSliderModule,
    SweetAlert2Module.forRoot({
      buttonsStyling: false,
      customClass: "modal-content",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn",
    }),
    Angular2PromiseButtonModule.forRoot(),
    CPipeModule,
    NgxMasonryModule,
    PdfJsViewerModule,
    NgxExtendedPdfViewerModule,
    IconModule,
  ],
  exports: [
    SharedPipeModule,
    PhotoTooltipsComponent,
    ClearButtonComponent,
    PhotoCardComponent,
    SuccessPageComponent,
    TagInputModule,
    IgxSliderModule,
    IgxInputGroupModule,
    MySlidePanelComponent,
    InputTextClearDirective,
    LazyLoadDirective,
    NgxCroppieModule,
    ReviewPopupComponent,
    RatingStarComponent,
    SweetAlert2Module,
    NgbModule,
    Angular2PromiseButtonModule,
    SharedLayoutModule,
    CarouselPhotoComponent,
    RestartingPopupComponent,
    VideoCardComponent,
    TravelKitTabComponent,
    IconModule,
  ],
  providers: [],
  entryComponents: [
    ClearButtonComponent,
    ReviewPopupComponent,
    PopupMarkerComponent,
    ContactPopupComponent,
  ],
})
export class SharedModule {}
